import React from 'react';
import PropTypes from 'prop-types';
import {TightKnitLogoWhite} from "../../images/images";
import InfoCard from "./InfoCard";

const AuthPage = ({children, className}) => (
    <div className={`auth-page ${className || ''}`}>
        <div className="auth-page__logo">
            <img src={TightKnitLogoWhite} className="logoImage "/>
        </div>

        <div className="auth-page__cards">
            <InfoCard />
            <div className="auth-page__card">
                {children}
            </div>
        </div>
    </div>
);

AuthPage.propTypes = {
    className: PropTypes.string
};

export default AuthPage;



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/AuthPage.js